import React from 'react';
import Logo from './Logo';
const Footer = () => {
  return <footer className="py-6 bg-gray-50 border-t border-gray-100" data-id="element-686">
      <div className="container px-4 mx-auto" data-id="element-687">
        <div className="flex flex-col items-center justify-between space-y-4 md:flex-row md:space-y-0" data-id="element-688">
          <div className="flex items-center" data-id="element-689">
            <a href="https://www.conversion.com.br/" target="_blank" rel="noopener noreferrer" className="flex items-center hover:opacity-80 transition-opacity" data-id="element-690">
              <Logo isFooter={true} data-id="element-691" />
            </a>
          </div>
          <div className="text-sm text-gray-500" data-id="element-692">
            © {new Date().getFullYear()} Conversion. Todos os direitos
            reservados.
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;